import {Checkbox, Col, Popover, Tabs} from "antd";
import React, { ReactElement, useState } from "react";
import { useDispatch } from "react-redux";
import { TabBar } from "../../compnents/widgets/TabBar";
import { Formula } from "./formula/formulas/formula";
import { NoFormula } from "./formula/noformula/noformula";
import styles from "./nurse.module.css";
import { UnexecutedPrescription } from "./formula/unexecutedPrescription/unexecutedPrescription";
import { ExecutedPrescription } from "./formula/executedPrescriptions/executedPrescriptions";
import {QuestionCircleTwoTone} from "@ant-design/icons";

const { TabPane } = Tabs;
export const Nurse = (): ReactElement => {
  const dispatch = useDispatch();
  const [showRefund, setShowRefund] = useState(true);
  const [selectTabKey, setSelectTabKey] = useState("0");
  return (
    <>
      <Col className={styles.container}>
          <TabBar
            style={{ marginBottom: '20px' }}
            tabBarExtraContent={{
              right: (
                <span style={{ marginRight: 16, display: 'flex', alignItems: 'center', gap: 4 }}>
                <Checkbox
                  checked={showRefund}
                  onChange={(e) => setShowRefund(e.target.checked)}
                >
                  包含退费数据
                </Checkbox>
                <Popover
                content={
                <div>
                <p>
                已退费数据无需执行，放在已执行处方里，如不要展示退费数据取消勾选
                </p>
                </div>
            }
            placement='bottom'
            title='说明'
          >
              <QuestionCircleTwoTone />
          </Popover>
                </span>
              ),
            }}
            onChange={(e) => {
              setSelectTabKey(e)
            }}
          >
            <TabPane key="0" tab="未执行处方">
              <UnexecutedPrescription showRefund={showRefund} selectTabKey={selectTabKey} />
            </TabPane>
            <TabPane key="1" tab="已执行处方">
              <ExecutedPrescription showRefund={showRefund} selectTabKey={selectTabKey} />
            </TabPane>
          </TabBar>
      </Col>
    </>
  );
};
